import { w as win } from "../chunks/common-namespaces-client-R41448Nc.mjs";
function defineNamespace$1(implementation) {
  return { ...implementation, [Symbol.onexus.namespace]: true };
}
function defineFunction$1(handler) {
  return handler;
}
function defineEvent$1(...listeners) {
  return { [Symbol.onexus.event]: listeners };
}
const defineEvent = defineEvent$1;
const createEventTopic = defineEvent$1;
const defineFunction = defineFunction$1;
const defineNamespace = defineNamespace$1;
const otto = win.otto ?? {};
export {
  createEventTopic,
  defineEvent,
  defineFunction,
  defineNamespace,
  otto
};
/*                                     */
